import colors from '@/styles/color.scss';
export function setCustomOptions(type) {
    let drawerOptions = {};
    switch (type) {
        case 'circle':
            drawerOptions = {
                normal: {
                    fillStyle: colors.circleFillStyle,
                    strokeStyle: colors.polygonStrokeStyle,
                    lineWidth: 2,
                },
                hover: {
                    fillStyle: colors.polygonFillStyleHover,
                    strokeStyle: colors.polygonStrokeStyle,
                    lineWidth: 4,
                },
            };
            break;
        case 'polygon':
            drawerOptions = {
                normal: {
                    fillStyle: colors.polygonFillStyle,
                    strokeStyle: colors.polygonStrokeStyle,
                    lineWidth: 2
                },
                hover: {
                    fillStyle: colors.polygonFillStyleHover,
                    strokeStyle: colors.polygonStrokeStyle,
                    lineWidth: 4,
                },
            };
            break;
        case 'rect':
            drawerOptions = {
                normal: {
                    fillStyle: colors.createTaskFrameNormal,
                    strokeStyle: colors.white,
                    lineWidth: 2,
                    globalAlpha: 1
                },
                hover: {
                    fillStyle: colors.createTaskFrameNormal,
                    strokeStyle: colors.createTaskFrameHover,
                    lineWidth: 2,
                    globalAlpha: 1
                },
            };
            break;
        case 'line':
        case 'lines':
            drawerOptions = {
                normal: {
                    fillStyle: colors.searchYellow,
                    strokeStyle: colors.searchYellow,
                    lineWidth: 2,
                    globalAlpha: 1
                }
            };
            break;
        case 'straight':
            drawerOptions = {
                normal: {
                    fillStyle: colors.lineFillStyle,
                    strokeStyle: colors.lineFillStyle,
                    lineWidth: 2,
                    globalAlpha: 0.3
                }
            };
            break;
        case 'arrow':
            drawerOptions = {
                normal: {
                    fillStyle: colors.lineFillStyle,
                    strokeStyle: colors.white,
                    lineWidth: 2,
                    globalAlpha: 0.3
                },
                hover: {
                    fillStyle: colors.lineFillStyle,
                    strokeStyle: colors.white,
                    lineWidth: 4,
                    globalAlpha: 0.8
                },
            };
            break;
        default:
            drawerOptions = {
                normal: {
                    fillStyle: colors.defaultFillStyle,
                    lineWidth: 2,
                    strokeStyle: colors.defaultFillStyle,
                },
                hover: {
                    fillStyle: colors.defaultFillStyleHover,
                    lineWidth: 3,
                    strokeStyle: colors.polygonStrokeStyle,
                },
                select: {
                    fillStyle: colors.polygonFillStyleHover,
                    lineWidth: 2,
                    strokeStyle: colors.polygonStrokeStyle,
                },
                // 是否支持凹多边形
                supportConcave: true,
                arrowWidth: 7,
                arrowHeight: 15,
            };
    }
    return drawerOptions;
}
export function setCustomOptionsColor(type, fillColors, strokeColor) {
    let drawerOptions = {};
    switch (type) {
        case 'circle':
            drawerOptions = {
                normal: {
                    fillStyle: fillColors,
                    strokeStyle: strokeColor,
                    lineWidth: 2,
                    globalAlpha: 0.1
                },
                hover: {
                    fillStyle: fillColors,
                    strokeStyle: strokeColor,
                    lineWidth: 4,
                    globalAlpha: 0.8
                },
            };
            break;
        case 'polygon':
            drawerOptions = {
                normal: {
                    fillStyle: fillColors,
                    strokeStyle: strokeColor,
                    lineWidth: 2,
                    globalAlpha: 0.3
                },
                hover: {
                    fillStyle: fillColors,
                    strokeStyle: strokeColor,
                    lineWidth: 4,
                    globalAlpha: 0.8
                },
            };
            break;
        case 'rect':
            drawerOptions = {
                normal: {
                    fillStyle: colors.white,
                    strokeStyle: colors.createTaskFrameHover,
                    lineWidth: 2,
                    globalAlpha: 0.3
                }
            };
            break;
        case 'line':
            drawerOptions = {
                normal: {
                    fillStyle: colors.lineFillStyle,
                    strokeStyle: colors.lineFillStyle,
                    lineWidth: 2,
                    globalAlpha: 0.3
                }
            };
            break;
        case 'arrow':
            drawerOptions = {
                normal: {
                    fillStyle: colors.lineFillStyle,
                    strokeStyle: colors.white,
                    lineWidth: 2,
                    globalAlpha: 0.3
                },
                hover: {
                    fillStyle: colors.lineFillStyle,
                    strokeStyle: colors.white,
                    lineWidth: 4,
                    globalAlpha: 0.8
                },
            };
            break;
        default:
            drawerOptions = {
                normal: {
                    fillStyle: fillColors,
                    globalAlpha: 0.5,
                    lineWidth: 2,
                    strokeStyle: strokeColor,
                },
                hover: {
                    fillStyle: fillColors,
                    globalAlpha: 0.6,
                    lineWidth: 3,
                    strokeStyle: strokeColor,
                },
                select: {
                    fillStyle: fillColors,
                    globalAlpha: 0.8,
                    lineWidth: 2,
                    strokeStyle: strokeColor,
                },
                // 是否支持凹多边形
                supportConcave: true,
                arrowWidth: 7,
                arrowHeight: 15,
            };
    }
    return drawerOptions;
}
